import React from 'react';

export function Level(props){
    return ( 
        <span  className="badge d-flex customized-badge rounded-border even-larger-badge " > Level:&nbsp; {props.level} </span>
    )
      
      
}